<template>
    <div v-if="block.display" @scroll="scrollEvent" ref="banner" @mouseleave="triggerOut()" class="home-block"
            v-observe-visibility="{
            callback: visibilityChanged,
            once: true,
            intersection:{
                rootMargin: `${block.observeMargin}px 0px ${block.observeMargin}px 0px`
            }
        }" :id="block.elementId">
        <h2 v-html="block.title"></h2>
        <div class="home-block-content">
            <div v-show="backShow" class="block-back" @click="back">
                <span class=" ecom-chevron-left"></span>
            </div>
            <div class="banner-content mt-0" ref="block" @scroll="scrollEvent"     
                v-observe-visibility="{
                    callback: blockVisibility,
                    intersection: {
                        threshold: 0.9,
                    },
                }">
                <div class="slider-margin">&nbsp;</div>
                <div v-if="block.isLoading" class="banner-item-slide" :style="{height: `${bannerHeight}px`}">
                    <div v-for="n in Math.ceil(nImages)" class="banner-item" :key="n" :style="{width: `${bannerWidth}px`,  height: `${bannerHeight}px`, top: `${bannerTop}px`}">
                        <div class="banner-item-border w-100 h-100 skeleton-box"></div>
                    </div>
                </div>
                <div  :class="{'banner-container': isVisible}" v-for="banner in block.dataContent" @mouseover="mouseMove(banner,$event)" @mousemove="mouseMove(banner,$event)" :key="banner.campaignId">
                    <SingleBanner
                            :banner="banner"
                            :isScrolled="isScrolled"
                            :bannerWidth="bannerWidth"
                            :bannerHeight="bannerHeight"
                            :bannerTop="bannerTop"
                    ></SingleBanner>
                </div>
                <div class="slider-margin">&nbsp;</div>
            </div>
            <div v-show="nextShow" class="block-next" @click="forward">
                <span class=" ecom-chevron-right"></span>
            </div>
                <div  v-show="bannerShow" :class="{'single-banner-expand': classDetail, 'single-banner-expand-right': classRight, 'single-banner-expand-left': classLeft, 'single-banner-transition': bannerShow}" class="single-banner" :style="`left: ${leftMouseover}px ; transform-origin: transformAlign; width: ${bannerWidth}px; z-index:999; height:100%; top:0px; border-radius: 2px;`" >
                <SingleBanner
                    v-if="bannerElement"
                    :banner="bannerElement"
                    :isScrolled="true"
                    :bannerWidth="bannerWidth"
                    :bannerHeight="bannerHeight"
                    :bannerTop="bannerTopExpand" 
                    :eventMouseLeave="triggerOut" 
                >
                </SingleBanner>
        </div>
    </div>
    </div>
</template>
<script>
import BlockImage from '../../Common/Partials/BlockImage';
import HomeBlock from '@/models/home-block';
import homeUtils from '@/Utilities/homeUtils';
import Video from '../../Common/Partials/VideoBanner';
//import TimeCounter from '../../Common/Partials/TimeCounter';
import SingleBanner from '../../Common/Partials/SingleBannerV2';
export default {
    components:{
        BlockImage,
        //TimeCounter,
        Video,
        SingleBanner
    },
    props:{
        block:{
            type: HomeBlock
        },
        margin:{
            type: Number,
            default: 3
        },
        defaultWidth:{
            type: Number,
            default: 824
        },
        defaultHeight:{
            type: Number,
            default: 410
        },
        borderWidth:{
            type: Number,
            default: 2
        }
    },
    data(){
        return{
            bannerWidth: 0,
            bannerHeight: 0,
            backShow: false,
            nextShow: false,
            bannerSelected: 0,
            viewWidth: 0,
            isScrolled: false,
            bannerElement: null,
            bannerTop:0,
            bannerTopExpand:-58,
            leftMouseover:0,
            bannerShow: false,
            classDetail: false,
            timerShow: null,
            timerClass: null,
            timerHide: null,
            timerX: null,
            timerRetry: null,
            timerMouseMove: null,
            isScrolled:false,
            scrollTimer: null,
            classRight: false,
            classLeft: false,
            isVisible: false
        }
    },
    mounted() {
        this.resize();
    },
    created() {
        window.addEventListener("resize", this.resize);
        document.addEventListener('mousemove',this.moveOutOfBlock);
        window.addEventListener("scroll", this.moveOutOfBlock);
    },
    updated(){
        const elem = this.$refs.block;
        if(elem && elem.scrollLeft == 0){
            this.nextShow = this.block.length > this.nImages;
        }
    },
    destroyed() {
        window.removeEventListener("resize", this.resize);
        document.removeEventListener('mousemove',this.moveOutOfBlock);
        window.removeEventListener("scroll", this.moveOutOfBlock);
    },
    computed: {
        nImages(){
            return this.block.numberItens;
        }
    },
    watch:{
        bannerShow(value){
            this.clearTimer();
            this.timerClass = setTimeout(() => {
                if(value){
                    this.classDetail=value;
                }
            },50)
        },

        classDetail(value){
            this.clearTimer();
            this.timerX = setTimeout(() => {
                if(!value){ 
                    this.bannerShow=value;
                }
            },250)
        }
    },
    methods: {
        visibilityChanged(isVisible){
            if(isVisible){
                this.block.load();
            }
        },
        blockVisibility(isVisible){
            this.isVisible = isVisible;
        },
        imgAlt(url){
            return url.replace(/\//g,' ').replace(/-/g,' ');
        },
        gotoUrl(url){
            homeUtils.gotoUrl(url,this.block);
        },
        colorBanner(banner){
            return banner.hasOwnProperty('css_class') && banner.css_class && banner.css_class.hasOwnProperty('slide_bgcolor') ? banner.css_class.slide_bgcolor : null;
        },
        moveOutOfBlock(e){
            if(!e){
                return;
            }
            let blockSelector = '#' + this.block.elementId;
            let target = e.target;
            if(!this.getClosest(target,blockSelector)){
                this.triggerOut();
            }
        },
        getClosest: function (elem, selector) {
            while (elem && elem.nodeType !== 9) {
                if (typeof elem.matches === 'function' && elem.matches(selector)) {
                    return elem;
                }
                elem = elem.parentNode;
            }            
            // for ( ; elem && elem !== document; elem = elem.parentNode ) {
            //     if ( elem.matches( selector ) ) return elem;
            // }
            return null;
        },        
        resize(){
            let isMobile        = this.block.platform == 2;
            this.viewWidth      = homeUtils.getViewPortWidth(isMobile);
            let marWidth        = Math.round(this.viewWidth * (this.margin * 2 / 100));
            let bWidth          = (this.viewWidth - marWidth) / this.nImages;
            this.bannerWidth    = Math.round(bWidth);
            this.bannerHeight   = this.defaultHeight * this.bannerWidth / this.defaultWidth;
              if(this.bannerElement){
                  this.bannerTop= 0;
              }
            //if(this.bannerHeight > this.defaultHeight){
            //    this.bannerHeight = this.defaultHeight;
            //}
        },
        scrollEvent(){
            this.triggerOut();
            this.bannerShow = false;
            const elem    = this.$refs.block;
            let marWidth  = Math.round(this.viewWidth * (this.margin * 2 / 100));
            const pos     = (elem.scrollLeft - marWidth) / this.bannerWidth;
            this.bannerSelected = Math.round(pos);
            this.nextShow = elem.scrollWidth > elem.scrollLeft + this.viewWidth + 10;
            if(!this.nextShow){
                const bnrs  = elem.querySelectorAll('.banner-item-slide');
                this.bannerSelected = bnrs.length - Math.floor(this.nImages);
            }
            this.backShow = elem.scrollLeft > 10;
            if(!this.backShow){
                this.bannerSelected = 0;
            }
            this.isScrolled = true;
        },
        back(){
            this.scrollMove(-1);
        },
        forward(){
            this.scrollMove(1);
        },
        scrollMove(direction){
            const elem  = this.$refs.block;
            const bnrs  = elem.querySelectorAll('.banner-item-slide');
            if(direction > 0 && this.bannerSelected>=(bnrs.length - 1)){
                return;
            }
            if(direction < 0 && this.bannerSelected<=0){
                return;
            }
            this.bannerSelected = this.bannerSelected + direction;
            let margin = Math.round(this.viewWidth * (this.margin / 100));
            let value  = bnrs[this.bannerSelected].offsetLeft - margin;
            this.smoothScrolling(elem,value);
        },
        smoothScrolling(e,value){
            e.scrollTo({
                top: 0, 
                left: value,
                behavior: 'smooth'
            });
        },
        mouseMove(banner,event){
            clearTimeout(this.timerMouseMove);
            let time = this.bannerShow || this.classDetail ? 330 : 100;
            this.timerMouseMove = setTimeout(()=>{
                this.triggerDetection(banner,event);
            },time);
        },
        triggerDetection(banner,event){
            //if(this.classDetail){
                //250ms of timerX + 50ms of timerHide + 100ms margin
            //    clearTimeout(this.timerRetry);
            //    this.timerRetry = setTimeout(() => {
            //        this.triggerDetection(banner, event);
            //    },400);
            //    return;
            //}
            let element = event.target ? this.getClosest(event.target,'.banner-container') : null;
            if(!element){
                return;
            }
            if(!this.bannerShow){
                this.clearTimer();
                this.bannerElement = banner;
            }
            this.timerShow = setTimeout(() => {  
                let vW = homeUtils.getViewPortWidth(true);
                let viewPort = homeUtils.getViewPortWidth();
                let container = ((vW - viewPort) / 2);
                let marWidth = Math.round(viewPort * (this.margin * 2 / 100));
                let position = element.getBoundingClientRect();
                this.leftMouseover = position.left - container - this.borderWidth + 2;
                this.bannerElement = banner;
                this.classRight = position.left - container + this.bannerWidth > viewPort - marWidth;
                this.classLeft  = position.left - container < marWidth;
                this.bannerShow = position.left - container + this.bannerWidth <= viewPort && position.left > 0;
            }, 50);
        },
        clearTimer(){
            clearTimeout(this.timerShow);
            this.timerShow = null;
            clearTimeout(this.timerHide);
            this.timerHide = null;
            clearTimeout(this.timerClass);
            this.timerClass = null;
            clearTimeout(this.timerX);
            this.timerX = null;
        }, 
        triggerOut(){
            if(!this.classDetail && !this.timerX){
                this.bannerShow=false;
            }            
            this.clearTimer();
            this.timerHide = setTimeout(() => {
                this.classDetail=false;
            },50)
        }
    }
}
</script>
